// ===== CONFIG — REPLACE THESE TWO VALUES =====
const FIREBASE_URL  = 'https://kanga-3cf60-default-rtdb.asia-southeast1.firebasedatabase.app/stateSales';
const WEB3FORMS_KEY = 'f9e99b1c-6bde-434f-bc6a-11252802312b';

// ===== STATE =====
let cart = JSON.parse(localStorage.getItem('af-cart') || '[]');
let countdownInterval = null;

// ===== IMAGE URL HELPER =====
// Converts local paths like 'assets/images/MY FILE.jpg' to Shopify Files CDN URLs.
// Already-absolute URLs (http/https) are returned unchanged.
function imgUrl(path) {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    const filename = path.replace(/^assets\/images\//, '').replace(/^assets\//, '');
    return (window.KANGA_CDN || '') + '/' + filename.replace(/ /g, '_');
}

// ===== NAVIGATION =====
function navigate(pageId, data) {
    const current = document.querySelector('.site-page.active');
    const target = document.getElementById('page-' + pageId);
    if (!target || current === target) return;

    _doNavigate(pageId, data);
    // Push a browser history entry so the native back button works.
    history.pushState({ pageId, data: data || null }, '', location.pathname + location.search + '#' + pageId);
}

function _doNavigate(pageId, data) {
    const current = document.querySelector('.site-page.active');
    const target = document.getElementById('page-' + pageId);
    if (!target) return;

    if (pageId === 'release-detail' && data) renderReleaseDetail(data);
    else if (pageId === 'product' && data) renderProductDetail(data);
    else if (pageId === 'shop') renderShopWaitlist();
    else if (pageId === 'releases') renderReleases();
    else if (pageId === 'cart') renderCart();
    else if (pageId === 'home') renderHome();
    else if (pageId === 'about') renderAbout();

    if (current) current.classList.remove('active');
    target.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'instant' });

    if (pageId === 'territory') {
        setTimeout(async () => {
            await loadStateSalesFromFirebase();
            initTerritoryMap();
        }, 80);
    }
    setTimeout(initScrollReveal, 80);

    document.querySelectorAll('.nav-link').forEach(l => {
        l.classList.toggle('nav-active', l.dataset.page === pageId);
    });

    document.getElementById('mobile-menu').classList.remove('open');
}

// ===== MOBILE MENU =====
function toggleMobileMenu() {
    document.getElementById('mobile-menu').classList.toggle('open');
}

// ===== HOME =====
function renderHome() {
    const grid = document.getElementById('home-products-grid');
    if (grid) {
        grid.innerHTML = SITE_DATA.products.map(p => productCardHTML(p)).join('');
    }

    const upcomingStrip = document.getElementById('home-upcoming-grid');
    if (upcomingStrip) {
        upcomingStrip.innerHTML = SITE_DATA.upcomingReleases.map(r => `
            <div class="upcoming-strip-card ${r.locked ? 'locked' : ''}" onclick="navigate('releases')">
                <div class="usc-bg">
                    <div class="usc-placeholder">
                        ${r.locked ? '<span class="lock-text">CLASSIFIED</span>' : '<span>TEASER VISUAL</span>'}
                    </div>
                    <div class="usc-overlay"></div>
                </div>
                <div class="usc-info">
                    <div class="usc-status">${r.status}</div>
                    <div class="usc-name">${r.name} — ${r.subtitle}</div>
                    <p class="usc-theme">${r.theme}</p>
                    ${r.locked ? '<div class="classified-tag">DETAILS CLASSIFIED</div>' : '<div class="classified-tag">COMING SOON</div>'}
                </div>
            </div>
        `).join('');
    }

    startCountdowns();
}

// ===== SHOP =====
function renderShop() {
    const grid = document.getElementById('shop-products-grid');
    if (grid) grid.innerHTML = SITE_DATA.products.map(p => productCardHTML(p, false)).join('');
}

// ===== PRODUCT CARD =====
function productCardHTML(product, small = true) {
    const mediaInner = product.image
        ? `<img src="${imgUrl(product.image)}" alt="${product.name}" class="product-photo" loading="lazy">`
        : `<div class="product-media-placeholder"><span>IMAGE / VIDEO</span></div>
           <video class="product-hover-video" muted loop playsinline preload="none"></video>`;
    return `
        <div class="product-card${small ? '' : ' large-card'}" onclick="navigate('product', '${product.id}')">
            <div class="product-media" style="background:${product.gradient}">
                ${product.tag ? `<div class="product-tag">${product.tag}</div>` : ''}
                <div class="product-wl-badge">WAITLIST</div>
                ${mediaInner}
                <div class="product-hover-cta">VIEW PRODUCT →</div>
            </div>
            <div class="product-info">
                <div class="product-name">${product.name}</div>
            </div>
        </div>
    `;
}

// ===== RELEASES =====
function renderReleases() {
    const currentEl = document.getElementById('current-release-content');
    if (currentEl) {
        const d = SITE_DATA.currentDrop;
        const heroProduct = SITE_DATA.products.find(p => p.id === 'navy-aus-first-longsleeve');
        currentEl.innerHTML = `
            <div class="current-drop-card" onclick="navigate('release-detail', 'current')">
                <div class="cdc-media">
                    ${heroProduct?.image ? `<img src="${imgUrl(heroProduct.image)}" alt="${d.name}" class="cdc-hero-img">` : ''}
                    <div class="cdc-overlay"></div>
                </div>
                <div class="cdc-info">
                    <div class="status-pill upcoming">${d.status}</div>
                    <h2>${d.name} — ${d.subtitle}</h2>
                    <p class="cdc-theme">${d.theme}</p>
                    <span class="text-link">VIEW FULL DROP →</span>
                </div>
            </div>
        `;
    }

    const upcomingEl = document.getElementById('upcoming-releases-content');
    if (upcomingEl) {
        upcomingEl.innerHTML = SITE_DATA.upcomingReleases.map(r => `
            <div class="upcoming-release-card ${r.locked ? 'locked' : ''}">
                <div class="urc-media">
                    <div class="urc-placeholder">
                        ${r.locked ? '<div class="classified-block">CLASSIFIED</div>' : '<span>TEASER</span>'}
                    </div>
                </div>
                <div class="urc-info">
                    <div class="status-pill upcoming">${r.status}</div>
                    <h3>${r.name} — ${r.subtitle}</h3>
                    <p>${r.theme}</p>
                    ${r.locked ? '<div class="classified-tag">DETAILS CLASSIFIED</div>' : '<div class="classified-tag">COMING SOON</div>'}
                </div>
            </div>
        `).join('');
    }

    const pastEl = document.getElementById('past-releases-content');
    if (pastEl) {
        pastEl.innerHTML = SITE_DATA.pastReleases.map(r => `
            <div class="past-release-card" onclick="navigate('release-detail', '${r.id}')">
                <div class="prc-media" style="background:${r.gradient || 'var(--bg2)'}">
                    <div class="prc-overlay"></div>
                    <div class="prc-pieces-badge">${r.pieces} PIECES</div>
                </div>
                <div class="prc-info">
                    <div class="status-pill archived">${r.status}</div>
                    <h3>${r.name} — ${r.subtitle}</h3>
                    <p class="prc-meta">${r.releaseDate || ''}</p>
                    <p>${r.theme}</p>
                </div>
            </div>
        `).join('');
    }

    startCountdowns();
}

// ===== RELEASE DETAIL =====
function renderReleaseDetail(releaseId) {
    const container = document.getElementById('release-detail-content');
    if (!container) return;

    let release, products, isCurrent = false;

    if (releaseId === 'current') {
        release = SITE_DATA.currentDrop;
        products = SITE_DATA.products;
        isCurrent = true;
    } else {
        release = SITE_DATA.pastReleases.find(r => r.id === releaseId);
        products = release?.products || [];
    }

    if (!release) return;

    const statusClass = (release.status || 'archived').toLowerCase();
    const heroProduct = SITE_DATA.products.find(p => p.id === 'navy-aus-first-longsleeve');

    const productGridHTML = isCurrent
        ? products.map(p => `
            <div class="rdp-card" onclick="navigate('product', '${p.id}')">
                <div class="rdp-media" style="background:#000">
                    ${p.image
                        ? `<img src="${imgUrl(p.image)}" alt="${p.name}" class="rdp-photo" loading="lazy">`
                        : `<div class="rdp-placeholder"><span>IMAGE</span></div>`
                    }
                    <div class="rdp-hover-cta">VIEW</div>
                </div>
                <div class="rdp-name">${p.name}</div>
            </div>
        `).join('')
        : products.map(p => `
            <div class="rdp-card archived">
                <div class="rdp-media archived-media">
                    <div class="rdp-placeholder"><span>ARCHIVED</span></div>
                </div>
                <div class="rdp-name">${p.name}</div>
                <div class="rdp-status-tag">${p.status}</div>
            </div>
        `).join('');

    container.innerHTML = `
        <div class="rd-hero">
            <div class="rd-hero-bg">
                ${isCurrent && heroProduct?.image
                    ? `<img src="${imgUrl(heroProduct.image)}" alt="${release.name}" class="rd-hero-img">`
                    : `<div class="rd-hero-placeholder"><span>DROP BANNER — VIDEO / IMAGE</span></div>`
                }
                <div class="rd-hero-overlay"></div>
            </div>
            <div class="rd-hero-content">
                <button class="back-btn" onclick="history.back()">← BACK</button>
                <div class="status-pill ${statusClass}">${release.status}</div>
                <h1 class="rd-title">${release.name}<br><span class="rd-subtitle">${release.subtitle}</span></h1>
                <div class="rd-meta-row">
                    <span>${release.releaseDate || 'COMING SOON'}</span>
                </div>
            </div>
        </div>
        <div class="rd-body">
            <section class="rd-collection scroll-reveal">
                <div class="section-header">
                    <h2>THE COLLECTION</h2>
                </div>
                <div class="rdp-grid">
                    ${productGridHTML}
                </div>
            </section>
            ${statusClass === 'archived' ? '<div class="rd-never-return scroll-reveal">THIS DROP WILL NEVER RETURN</div>' : ''}
        </div>
    `;
}

// ===== PRODUCT DETAIL =====
function renderProductDetail(productId) {
    const container = document.getElementById('product-detail-content');
    const product = SITE_DATA.products.find(p => p.id === productId);
    if (!product || !container) return;

    const statsHTML = product.stats
        ? Object.entries(product.stats).filter(([k]) => k !== 'MATERIAL').map(([k, v]) => `
            <div class="pd-stat">
                <div class="pd-stat-key">${k}</div>
                <div class="pd-stat-val">${v}</div>
            </div>
        `).join('') : '';

    const defaultSize = product.sizes[0] || '';
    const imgs = product.images && product.images.length ? product.images : (product.image ? [product.image] : []);
    const resolvedImgs = imgs.map(src => imgUrl(src));

    const thumbsHTML = resolvedImgs.length > 1
        ? resolvedImgs.map((src, i) => `<img src="${src}" alt="${product.name} view ${i+1}" class="pd-thumb${i===0?' active':''}" onclick="switchPhoto(this,'${src}')" loading="lazy">`).join('')
        : '';

    container.innerHTML = `
        <div class="pd-wrap">
            <div class="pd-media-col">
                <div class="pd-hero-media">
                    ${resolvedImgs.length
                        ? `<img src="${resolvedImgs[0]}" alt="${product.name}" class="pd-photo" id="pd-main-photo">`
                        : `<div class="pd-media-placeholder" style="background:${product.gradient}"><span>PRODUCT IMAGE</span></div>`
                    }
                </div>
                ${thumbsHTML ? `<div class="pd-thumbs">${thumbsHTML}</div>` : ''}
            </div>
            <div class="pd-info-col">
                <button class="back-btn" onclick="history.back()">← BACK</button>
                <div class="pd-drop-tag">AUSFIRST#001 — FOUNDATIONS</div>
                <h1 class="pd-name">${product.name}</h1>

                ${statsHTML ? `<div class="pd-stats">${statsHTML}</div>` : ''}

                <div class="pd-size-section">
                    <div class="pd-size-label">SELECT YOUR SIZE</div>
                    <div class="pd-sizes" id="pd-sizes">
                        ${product.sizes.map((s, i) => `
                            <button class="size-btn${i === 0 ? ' selected' : ''}" onclick="selectSize(this, '${product.id}')">${s}</button>
                        `).join('')}
                    </div>
                </div>

                <div class="pd-waitlist-area">
                    <div class="pd-wl-heading">JOIN THE WAITLIST FOR THIS PIECE</div>
                    <p class="pd-wl-sub">Select your size above then enter your email — you'll be first in line when this drops.</p>
                    <form class="pd-wl-form" id="pd-wl-form" onsubmit="event.preventDefault(); submitProductWaitlist('${product.id}')">
                        <select id="pd-wl-state" class="wl-state-select pd-wl-state" required>
                            <option value="" disabled selected>SELECT YOUR REGION</option>
                            <option value="NSW">NEW SOUTH WALES</option>
                            <option value="VIC">VICTORIA</option>
                            <option value="QLD">QUEENSLAND</option>
                            <option value="WA">WESTERN AUSTRALIA</option>
                            <option value="SA">SOUTH AUSTRALIA</option>
                            <option value="TAS">TASMANIA</option>
                            <option value="NT">NORTHERN TERRITORY</option>
                            <option value="ACT">AUSTRALIAN CAPITAL TERRITORY</option>
                        </select>
                        <div class="pd-wl-row">
                            <input type="email" id="pd-wl-email" class="pd-wl-input" placeholder="YOUR EMAIL ADDRESS" required autocomplete="email">
                            <button type="submit" class="pd-wl-submit" id="pd-wl-btn">JOIN WAITLIST — ${defaultSize} →</button>
                        </div>
                        <p class="pd-wl-note">Size + region required · No spam · Early access only</p>
                    </form>
                    <div class="pd-wl-success" id="pd-wl-success" style="display:none">
                        <div class="pd-wl-success-icon">✓</div>
                        <p class="pd-wl-success-msg">YOU'RE ON THE LIST.</p>
                        <p class="pd-wl-success-sub">We'll notify you when ${product.name} drops.</p>
                    </div>
                </div>
            </div>
        </div>
    `;
}

function switchPhoto(thumb, src) {
    const main = document.getElementById('pd-main-photo');
    if (main) main.src = src;
    thumb.closest('.pd-thumbs').querySelectorAll('.pd-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
}

function selectSize(btn, productId) {
    btn.closest('.pd-sizes').querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    const submitBtn = document.getElementById('pd-wl-btn');
    if (submitBtn) submitBtn.textContent = `JOIN WAITLIST — ${btn.textContent.trim()} →`;
}

// ===== WAITLIST =====

let waitlistEntries = JSON.parse(localStorage.getItem('kanga-waitlist') || '[]');
let waitlistPendingState = false;
let waitlistPendingSource = null;

function saveWaitlist() {
    localStorage.setItem('kanga-waitlist', JSON.stringify(waitlistEntries));
}

function isEmailOnList(email) {
    return waitlistEntries.some(e => e.email === email);
}

function addWaitlistEntry(email, product = null, size = null, source = 'general', state = null) {
    const form_id   = product ? `waitlist-${product.id}` : 'general-waitlist';
    const form_name = product ? `Waitlist — ${product.name}` : 'General Waitlist — AUSFIRST#001';

    const entry = {
        email,
        timestamp:      new Date().toISOString(),
        source,
        form_id,
        form_name,
        product_id:     product?.id   ?? null,
        product_handle: product?.id   ?? null,
        product_name:   product?.name ?? null,
        variant_title:  size          ?? null,
        drop:           product?.drop ?? null,
        state:          state         ?? null,
    };
    waitlistEntries.push(entry);
    saveWaitlist();
    updateWaitlistCount();
    return entry;
}

function updateWaitlistCount() {
    const total = Object.values(stateSales).reduce((sum, n) => sum + (n || 0), 0);
    document.querySelectorAll('#wl-count').forEach(el => el.textContent = total);
}

// Send email notification via Web3Forms (bypasses Shopify password restriction)
async function sendEmailNotification(subject, message, replyEmail) {
    if (!WEB3FORMS_KEY || WEB3FORMS_KEY === 'YOUR_WEB3FORMS_KEY') return;
    try {
        const res = await fetch('https://api.web3forms.com/submit', {
            method: 'POST',
            body: JSON.stringify({
                access_key:  WEB3FORMS_KEY,
                subject:     subject,
                from_name:   'KANGA Waitlist',
                email:       replyEmail,
                message:     message
            }),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
        const data = await res.json();
        if (!data.success) console.warn('Web3Forms error:', data.message);
    } catch(err) {
        console.warn('Email notification error:', err);
    }
}

// Try to create a Shopify customer record (only works when storefront password is OFF)
async function addToShopifyCustomers(email, tags) {
    if (!window.KANGA_CSRF) return;
    const params = new URLSearchParams();
    params.append('form_type', 'customer');
    params.append('utf8', '✓');
    params.append('authenticity_token', window.KANGA_CSRF);
    params.append('customer[email]', email);
    params.append('customer[accepts_marketing]', 'true');
    params.append('customer[tags]', tags);
    try {
        await fetch('/contact', {
            method: 'POST',
            body: params,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    } catch(err) {
        // Silently fail — storefront password may be on
    }
}

// General waitlist — shop page
async function submitWaitlist(e) {
    e.preventDefault();
    const email = document.getElementById('wl-email')?.value.trim().toLowerCase();
    const state = document.getElementById('wl-state')?.value;
    if (!email || !state) return;

    const btn = document.getElementById('wl-submit-btn');
    if (btn) btn.disabled = true;

    // 1. Save locally
    addWaitlistEntry(email, null, null, 'general', state);

    // 2. Email notification via Web3Forms (works immediately, no Shopify restrictions)
    await sendEmailNotification(
        'KANGA Waitlist Sign-Up',
        'KANGA Waitlist Sign-Up\nDrop: AUSFIRST#001 — FOUNDATIONS\nState: ' + state + '\nEmail: ' + email,
        email
    );

    // 3. Try Shopify customer creation (only works when storefront password is off)
    addToShopifyCustomers(email, 'waitlist,kanga-001,region-' + state.toLowerCase());

    // 4. Update shared Firebase counter
    if (stateSales[state] !== undefined) {
        stateSales[state]++;
        updateMapCounters();
        incrementFirebaseState(state);
    }

    showWaitlistSuccess("YOU'RE ON THE LIST.");
}

// Product waitlist — product page
async function submitProductWaitlist(productId) {
    const product = SITE_DATA.products.find(p => p.id === productId);
    if (!product) return;

    const email   = document.getElementById('pd-wl-email')?.value.trim().toLowerCase();
    const state   = document.getElementById('pd-wl-state')?.value;
    const sizeBtn = document.querySelector('#pd-sizes .size-btn.selected');

    if (!email)   { document.getElementById('pd-wl-email')?.focus(); return; }
    if (!state)   { document.getElementById('pd-wl-state')?.focus(); return; }
    if (!sizeBtn) return;

    const size = sizeBtn.textContent.trim();
    const btn  = document.getElementById('pd-wl-btn');
    if (btn) btn.disabled = true;

    // 1. Save locally
    addWaitlistEntry(email, product, size, 'product', state);

    // 2. Email notification via Web3Forms
    await sendEmailNotification(
        'KANGA Product Waitlist — ' + product.name,
        'KANGA Product Waitlist Sign-Up\nProduct: ' + product.name + '\nSize: ' + size + '\nState: ' + state + '\nDrop: AUSFIRST#001 — FOUNDATIONS\nEmail: ' + email,
        email
    );

    // 3. Try Shopify customer creation
    addToShopifyCustomers(email, 'waitlist,kanga-001,' + product.id + ',size-' + size.toLowerCase() + ',region-' + state.toLowerCase());

    // 4. Update shared Firebase counter
    if (stateSales[state] !== undefined) {
        stateSales[state]++;
        updateMapCounters();
        incrementFirebaseState(state);
    }

    showPdSuccess("YOU'RE ON THE LIST.");
}

function showWaitlistSuccess(msg) {
    const form = document.getElementById('wl-form');
    const success = document.getElementById('wl-success');
    const msgEl = document.querySelector('.wl-success-msg');
    if (form) form.style.display = 'none';
    if (msgEl) msgEl.textContent = msg;
    if (success) success.classList.add('visible');
}

function showPdSuccess(msg) {
    const form = document.getElementById('pd-wl-form');
    const success = document.getElementById('pd-wl-success');
    if (form) form.style.display = 'none';
    if (success) {
        const msgEl = success.querySelector('.pd-wl-success-msg');
        if (msgEl) msgEl.textContent = msg;
        success.style.display = 'flex';
    }
}

function renderShopWaitlist() {
    const form = document.getElementById('wl-form');
    const success = document.getElementById('wl-success');
    if (form) form.style.display = '';
    if (success) success.classList.remove('visible');
    updateWaitlistCount();
    renderShop();
}

// ===== CART =====
function addToCart(productId) {
    const product = SITE_DATA.products.find(p => p.id === productId);
    if (!product) return;

    const selectedBtn = document.querySelector('.size-btn.selected');
    const size = selectedBtn ? selectedBtn.textContent : product.sizes[0];

    const existing = cart.find(i => i.id === productId && i.size === size);
    if (existing) {
        existing.qty++;
    } else {
        cart.push({ id: productId, name: product.name, price: product.price, size, qty: 1 });
    }

    localStorage.setItem('af-cart', JSON.stringify(cart));
    updateCartCount();

    const btn = document.querySelector('.atc-btn');
    if (btn) {
        const orig = btn.textContent;
        btn.textContent = 'ADDED TO CART ✓';
        btn.classList.add('added');
        setTimeout(() => { btn.textContent = orig; btn.classList.remove('added'); }, 2000);
    }
}

function removeFromCart(idx) {
    cart.splice(idx, 1);
    localStorage.setItem('af-cart', JSON.stringify(cart));
    updateCartCount();
    renderCart();
}

function updateCartCount() {
    const total = cart.reduce((s, i) => s + i.qty, 0);
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = total > 0 ? total : '');
}

function renderCart() {
    const itemsEl = document.getElementById('cart-items');
    const summaryEl = document.getElementById('cart-summary');
    if (!itemsEl) return;

    if (cart.length === 0) {
        itemsEl.innerHTML = `
            <div class="cart-empty">
                <p>YOUR CART IS EMPTY</p>
                <button class="cta-btn" onclick="navigate('shop')">SHOP THE DROP →</button>
            </div>
        `;
        if (summaryEl) summaryEl.innerHTML = '';
        return;
    }

    itemsEl.innerHTML = cart.map((item, i) => `
        <div class="cart-item">
            <div class="ci-info">
                <div class="ci-name">${item.name}</div>
                <div class="ci-meta">SIZE: ${item.size} &nbsp;·&nbsp; QTY: ${item.qty}</div>
            </div>
            <div class="ci-right">
                <div class="ci-price">$${(item.price * item.qty).toFixed(2)}</div>
                <button class="ci-remove" onclick="removeFromCart(${i})">✕</button>
            </div>
        </div>
    `).join('');

    const subtotal = cart.reduce((s, i) => s + i.price * i.qty, 0);
    if (summaryEl) {
        summaryEl.innerHTML = `
            <div class="cart-subtotal-row">
                <span>SUBTOTAL</span>
                <span>$${subtotal.toFixed(2)} AUD</span>
            </div>
            <div class="cart-note">Shipping & taxes calculated at checkout</div>
            <button class="atc-btn full" onclick="showStateModal()">PROCEED TO CHECKOUT</button>
        `;
    }
}

// ===== ABOUT PAGE =====
function renderAbout() {
    const shuffled = [...SITE_DATA.products].sort(() => Math.random() - 0.5);
    const mediaSlots = document.querySelectorAll('#page-about .movement-media');
    mediaSlots.forEach((slot, i) => {
        const src = imgUrl(shuffled[i % shuffled.length].image);
        slot.innerHTML = `<img src="${src}" alt="KANGA" class="about-media-img">`;
    });
}

// ===== STATE SALES — FIREBASE SHARED COUNTER =====
let stateSales = { WA: 0, NT: 0, QLD: 0, SA: 0, NSW: 0, VIC: 0, TAS: 0, ACT: 0 };

async function loadStateSalesFromFirebase() {
    if (!FIREBASE_URL || FIREBASE_URL.includes('YOUR_FIREBASE_URL')) return;
    try {
        const res = await fetch(FIREBASE_URL + '.json');
        if (res.ok) {
            const data = await res.json();
            if (data && typeof data === 'object') {
                stateSales = { ...stateSales, ...data };
                updateMapCounters();
                updateWaitlistCount();
            }
        }
    } catch(e) {
        console.warn('Firebase load failed, showing local counts:', e);
    }
}

async function incrementFirebaseState(state) {
    if (!FIREBASE_URL || FIREBASE_URL.includes('YOUR_FIREBASE_URL')) return;
    try {
        await fetch(FIREBASE_URL + '.json', {
            method: 'PATCH',
            body: JSON.stringify({ [state]: { '.sv': { 'increment': 1 } } }),
            headers: { 'Content-Type': 'application/json' }
        });
    } catch(e) {
        console.warn('Firebase increment failed:', e);
    }
}

function updateMapCounters() {
    Object.keys(stateSales).forEach(code => {
        const el = document.getElementById('count-' + code);
        if (el) el.textContent = stateSales[code];
    });
}

function recordStateSale(stateCode) {
    if (stateSales[stateCode] !== undefined) {
        stateSales[stateCode]++;
        updateMapCounters();
        incrementFirebaseState(stateCode);
    }
    closeStateModal();

    if (waitlistPendingState) {
        if (waitlistEntries.length > 0) {
            waitlistEntries[waitlistEntries.length - 1].state = stateCode;
            saveWaitlist();
        }
        waitlistPendingState = false;
        if (waitlistPendingSource === 'product') {
            showPdSuccess("YOU'RE ON THE LIST.");
        } else {
            showWaitlistSuccess("YOU'RE ON THE LIST.");
        }
        waitlistPendingSource = null;
    } else {
        cart = [];
        localStorage.setItem('af-cart', JSON.stringify(cart));
        updateCartCount();
        renderCart();
        showConfirmation(stateCode);
    }
}

function showConfirmation(stateCode) {
    const msg = document.createElement('div');
    msg.className = 'checkout-confirm';
    msg.innerHTML = `<span>ORDER PLACED — ${SITE_DATA.territories[stateCode]?.name || stateCode} +1 SALE</span>`;
    document.body.appendChild(msg);
    setTimeout(() => msg.classList.add('in'), 10);
    setTimeout(() => { msg.classList.remove('in'); setTimeout(() => msg.remove(), 400); }, 3000);
}

function showStateModal() {
    if (cart.length === 0) return;
    const modal = document.getElementById('state-modal');
    const h2 = modal?.querySelector('.sm-header h2');
    const p = modal?.querySelector('.sm-header p');
    if (h2) h2.textContent = 'SELECT YOUR STATE';
    if (p) p.textContent = 'This records a sale to your territory and updates the map.';
    if (modal) modal.classList.add('open');
}

function closeStateModal() {
    const modal = document.getElementById('state-modal');
    if (modal) modal.classList.remove('open');
}

// ===== WAITLIST POPUP =====
function initWaitlistPopup() {
    if (sessionStorage.getItem('kanga-popup-shown')) return;
    const popup = document.getElementById('waitlist-popup');
    if (!popup) return;

    setTimeout(() => {
        // Skip it if they're already on the waitlist page.
        if (document.getElementById('page-shop')?.classList.contains('active')) return;
        popup.classList.add('visible');
        sessionStorage.setItem('kanga-popup-shown', '1');
    }, 4000);
}

function closeWaitlistPopup() {
    const popup = document.getElementById('waitlist-popup');
    if (popup) popup.classList.remove('visible');
}

// ===== TERRITORY MAP =====
function initTerritoryMap() {
    updateMapCounters();
    const states = document.querySelectorAll('#australia-svg .state-fill');
    const panel = document.getElementById('territory-info-panel');

    states.forEach(state => {
        const fresh = state.cloneNode(true);
        state.parentNode.replaceChild(fresh, state);
    });

    document.querySelectorAll('#australia-svg .state-fill').forEach(state => {
        const id = state.id.replace('state-', '');
        const data = SITE_DATA.territories[id];
        if (!data) return;

        state.addEventListener('click', () => {
            document.querySelectorAll('#australia-svg .state-fill').forEach(s => s.classList.remove('selected'));
            state.classList.add('selected');

            if (panel && data) {
                const statusClass = data.status.toLowerCase().replace(/\s/g, '-');
                const sales = stateSales[id] || 0;
                panel.innerHTML = `
                    <div class="tp-content">
                        <div class="tp-status ${statusClass}">${data.status}</div>
                        <h3 class="tp-name">${data.name}</h3>
                        <p class="tp-full">${data.fullName}</p>
                        <p class="tp-desc">${data.description}</p>
                        ${data.drop ? `<div class="tp-drop">${data.drop}</div>` : ''}
                        <div class="tp-sales-row">
                            <span class="tp-sales-label">SIGN UPS FROM THIS REGION</span>
                            <span class="tp-sales-count">${sales}</span>
                        </div>
                    </div>
                `;
                panel.classList.add('active');
            }
        });
    });
}

// ===== COUNTDOWN HELPERS =====
function countdownHTML(timestamp) {
    return `
        <div class="countdown-timer" data-ts="${timestamp}">
            <div class="ct-unit"><span class="ct-num" data-part="days">--</span><span class="ct-label">DAYS</span></div>
            <span class="ct-sep">:</span>
            <div class="ct-unit"><span class="ct-num" data-part="hours">--</span><span class="ct-label">HRS</span></div>
            <span class="ct-sep">:</span>
            <div class="ct-unit"><span class="ct-num" data-part="mins">--</span><span class="ct-label">MIN</span></div>
            <span class="ct-sep">:</span>
            <div class="ct-unit"><span class="ct-num" data-part="secs">--</span><span class="ct-label">SEC</span></div>
        </div>
    `;
}

function startCountdowns() {
    clearInterval(countdownInterval);

    function tick() {
        document.querySelectorAll('.countdown-timer').forEach(timer => {
            const ts = parseInt(timer.dataset.ts);
            const diff = ts - Date.now();

            if (diff <= 0) {
                timer.innerHTML = '<div class="ct-live">LIVE NOW</div>';
                return;
            }

            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff % 86400000) / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);

            const set = (part, val) => {
                const el = timer.querySelector(`[data-part="${part}"]`);
                if (el) el.textContent = String(val).padStart(2, '0');
            };

            set('days', d);
            set('hours', h);
            set('mins', m);
            set('secs', s);
        });
    }

    tick();
    countdownInterval = setInterval(tick, 1000);
}

// ===== PRODUCT HOVER VIDEO =====
function initProductHovers() {
    document.addEventListener('mouseenter', e => {
        if (!e.target || typeof e.target.closest !== 'function') return;
        const card = e.target.closest('.product-card');
        if (!card) return;
        const v = card.querySelector('.product-hover-video');
        if (v && v.querySelector('source')) v.play().catch(() => {});
    }, true);

    document.addEventListener('mouseleave', e => {
        if (!e.target || typeof e.target.closest !== 'function') return;
        const card = e.target.closest('.product-card');
        if (!card) return;
        const v = card.querySelector('.product-hover-video');
        if (v) { v.pause(); v.currentTime = 0; }
    }, true);
}

// ===== NAV SCROLL =====
function initNavScroll() {
    const nav = document.getElementById('navbar');
    window.addEventListener('scroll', () => {
        nav?.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
}

// ===== SCROLL REVEAL =====
function initScrollReveal() {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(e => {
            if (e.isIntersecting) {
                e.target.classList.add('revealed');
                observer.unobserve(e.target);
            }
        });
    }, { threshold: 0.12 });

    document.querySelectorAll('.scroll-reveal:not(.revealed)').forEach(el => observer.observe(el));
}

// ===== ADMIN DATA ACCESS =====
function _wlCSV(entries) {
    const cols = ['email','form_id','form_name','product_id','product_name','variant_title','drop','state','source','timestamp'];
    const rows = entries.map(e => cols.map(c => JSON.stringify(e[c] ?? '')).join(','));
    return [cols.join(','), ...rows].join('\n');
}

window.KANGA_ADMIN = {
    listForms() {
        const map = {};
        waitlistEntries.forEach(e => {
            const id = e.form_id || 'unknown';
            if (!map[id]) map[id] = { form_name: e.form_name, form_id: id, count: 0 };
            map[id].count++;
        });
        const forms = Object.values(map);
        console.table(forms);
        return forms;
    },
    exportFormCSV(formId) {
        const entries = waitlistEntries.filter(e => e.form_id === formId);
        if (!entries.length) { console.warn(`No entries for form: ${formId}`); return ''; }
        const csv = _wlCSV(entries);
        console.log(`%c— ${formId} (${entries.length} entries) —\n\n` + csv, 'color:#FF5E00');
        return csv;
    },
    exportAllCSV() {
        const csv = _wlCSV(waitlistEntries);
        console.log('%c— ALL FORMS —\n\n' + csv, 'color:#FF5E00');
        return csv;
    },
    exportJSON:    () => JSON.stringify(waitlistEntries, null, 2),
    getWaitlist:   () => waitlistEntries,
    getByForm: (formId) => waitlistEntries.filter(e => e.form_id === formId),
    clearWaitlist() {
        if (!confirm('Clear all waitlist data?')) return;
        waitlistEntries = [];
        saveWaitlist();
        updateWaitlistCount();
        console.log('Waitlist cleared.');
    },
    getFirebaseCounts: async () => {
        const res = await fetch(FIREBASE_URL + '.json');
        const data = await res.json();
        console.table(data);
        return data;
    }
};
console.log('%cKANGA ADMIN ready — KANGA_ADMIN.listForms() to see sign-ups.', 'color:#FF5E00;font-weight:bold;font-size:13px');

// ===== INIT =====
document.addEventListener('DOMContentLoaded', () => {
    loadStateSalesFromFirebase();
    updateCartCount();
    updateWaitlistCount();
    renderAbout();

    renderHome();
    initNavScroll();
    initScrollReveal();
    initProductHovers();
    initWaitlistPopup();
    // Push the home page as the first history entry so the back button
    // works correctly within the SPA.
    history.replaceState({ pageId: 'home', data: null }, '', location.pathname + location.search + '#home');

    // Handle browser back/forward button within the SPA.
    // When navigate() is called it pushes a history state; popstate fires
    // when the user navigates via browser controls.
    window.addEventListener('popstate', (e) => {
        if (e.state && e.state.pageId) {
            _doNavigate(e.state.pageId, e.state.data || undefined);
        } else {
            _doNavigate('home');
        }
    });
});
